document.addEventListener("DOMContentLoaded", function () {
  const checkButton = document.getElementById("check-chanel-code");
  
  if (checkButton) {
    checkButton.addEventListener("click", function () {
      const serialNumber = document.getElementById("chanel-code").value.trim();
      const resultElement = document.getElementById("chanel-result");
      
      // Kein Code eingegeben
      if (serialNumber === "") {
        resultElement.textContent = "Bitte geben Sie eine Seriennummer ein.";
        return;
      }
      
      // Seriennummer-Bereiche
      const serialNumberRanges = {
        '0': '1986-1988',
        '1': '1989-1991',
        '2': '1991-1994',
        '3': '1994-1996',
        '4': '1996-1997',
        '5': '1997-1999',
        '6': '2000-2002',
        '7': '2002-2003',
        '8': '2003-2004',
        '9': '2004-2005',
        '10': '2005-2006',
        '11': '2006-2008',
        '12': '2008-2009',
        '13': '2009-2010',
        '14': '2010-2011',
        '15': '2011',
        '16': '2012',
        '17': '2012-2013',
        '18': '2013-2014',
        '19': '2014',
        '20': '2014-2015',
        '21': '2015-2016',
        '22': '2016-2017',
        '23': '2016-2017',
        '24': '2017-2018',
        '25': '2018',
        '26': '2018-2019',
        '27': '2019',
        '28': '2019',
        '29': '2019',
        '30': '2020',
        '31': '2021'
      };
      
      let result;
      
      // Logik für Seriennummern
      if (serialNumber.length === 6) {
        result = "1984-1986";
      } else if (serialNumber.length === 7) {
        const firstDigit = serialNumber.charAt(0);
        result = serialNumberRanges[firstDigit];
      } else if (serialNumber.length === 8) {
        const firstTwoDigits = parseInt(serialNumber.slice(0, 2));
        result = serialNumberRanges[firstTwoDigits];
      }
      
      // Ergebnis anzeigen
      if (result) {
        resultElement.textContent = "Die Tasche wurde hergestellt in: " + result ;
      } else {
        resultElement.textContent = "Dies ist keine gültige Seriennummer.";
      }
    });
  }
});